// Trim user-typed matcher fields before a trigger is saved (issue #15).
// The Command Keyword input used to be saved verbatim, so "!so " (trailing
// space) was stored and then never matched "!so @friend". The backend matcher
// trims too; this keeps stored data clean.
export interface TrimmableTriggerConfig {
  keyword?: string;
  keywords?: string[];
  pattern?: string;
  [key: string]: unknown;
}

export function normalizeTriggerConfig<T extends TrimmableTriggerConfig>(
  config: T,
): T {
  const next = { ...config };
  if (typeof next.keyword === "string") next.keyword = next.keyword.trim();
  if (Array.isArray(next.keywords)) {
    next.keywords = next.keywords.map((k) => k.trim()).filter((k) => k);
  }
  if (typeof next.pattern === "string") next.pattern = next.pattern.trim();
  return next;
}
